import { DEFlagArt } from '@/shared/assets/icons/flags/de-flag-art';
import { ESFlagArt } from '@/shared/assets/icons/flags/es-flag-art';
import { FIFlagArt } from '@/shared/assets/icons/flags/fi-flag-art';
import { FRFlagArt } from '@/shared/assets/icons/flags/fr-flag-art';
import { HUFlagArt } from '@/shared/assets/icons/flags/hu-flag-art';
import { ITFlagArt } from '@/shared/assets/icons/flags/it-flag-art';
import { JAFlagArt } from '@/shared/assets/icons/flags/ja-flag-art';
import { KOFlagArt } from '@/shared/assets/icons/flags/ko-flag-art';
import { NLFlagArt } from '@/shared/assets/icons/flags/nl-flag-art';
import { PLFlagArt } from '@/shared/assets/icons/flags/pl-flag-art';
import { PTFlagArt } from '@/shared/assets/icons/flags/pt-flag-art';
import { SKFlagArt } from '@/shared/assets/icons/flags/sk-flag-art';
import { SVFlagArt } from '@/shared/assets/icons/flags/sv-flag-art';
import { USFlagArt } from '@/shared/assets/icons/flags/us-flag-art';
import {
  TLanguage,
  UiLanguageEnum,
} from '@/shared/features/language-switcher/language-switcher.types';

const languageSortCollator = new Intl.Collator('en', { sensitivity: 'base' });

// The flag art without BaseIcon, so Modern reads the list without pulling MUI in.
export const LANGUAGES: TLanguage[] = [
  {
    code: UiLanguageEnum.ENGLISH,
    FlagArt: USFlagArt,
    sortLabel: 'English',
  },
  {
    code: UiLanguageEnum.GERMAN,
    FlagArt: DEFlagArt,
    sortLabel: 'Deutsch',
  },
  {
    code: UiLanguageEnum.SPANISH,
    FlagArt: ESFlagArt,
    sortLabel: 'Español',
  },
  {
    code: UiLanguageEnum.PORTUGUESE,
    FlagArt: PTFlagArt,
    sortLabel: 'Português',
  },
  {
    code: UiLanguageEnum.ITALIAN,
    FlagArt: ITFlagArt,
    sortLabel: 'Italiano',
  },
  {
    code: UiLanguageEnum.FRENCH,
    FlagArt: FRFlagArt,
    sortLabel: 'Français',
  },
  {
    code: UiLanguageEnum.JAPANESE,
    FlagArt: JAFlagArt,
    sortLabel: '日本語',
  },
  {
    code: UiLanguageEnum.KOREAN,
    FlagArt: KOFlagArt,
    sortLabel: '한국어',
  },
  {
    code: UiLanguageEnum.DUTCH,
    FlagArt: NLFlagArt,
    sortLabel: 'Nederlands',
  },
  {
    code: UiLanguageEnum.FINNISH,
    FlagArt: FIFlagArt,
    sortLabel: 'Suomi',
  },
  {
    code: UiLanguageEnum.HUNGARIAN,
    FlagArt: HUFlagArt,
    sortLabel: 'Magyar',
  },
  {
    code: UiLanguageEnum.POLISH,
    FlagArt: PLFlagArt,
    sortLabel: 'Polski',
  },
  {
    code: UiLanguageEnum.SLOVAK,
    FlagArt: SKFlagArt,
    sortLabel: 'Slovenčina',
  },
  {
    code: UiLanguageEnum.SWEDISH,
    FlagArt: SVFlagArt,
    sortLabel: 'Svenska',
  },
].sort((left, right) =>
  languageSortCollator.compare(left.sortLabel, right.sortLabel),
);
